import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TranslationType } from "../types";

interface NotesFieldProps {
  register: any;
  t: TranslationType;
}

export const NotesField = ({ register, t }: NotesFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="notes">{t.additionalNotes}</Label>
      <Input id="notes" {...register("notes")} />
    </div>
  );
};
